import { useState } from "react";

import { BaseModal } from "./BaseModal";
import { useEffectAfterMigration } from "../../hooks/useEffectAfterMigration";

const ACCOUNT_ONBOARD = "accountOnBoard";

export default function OnBoardingModal({
  isUserLoggedIn,
}: {
  isUserLoggedIn: boolean;
}) {
  const [isOpen, setIsOpen] = useState(false);

  let accountOnBoard = localStorage.getItem(ACCOUNT_ONBOARD);

  const handleClose = () => {
    setIsOpen(false);
    localStorage.setItem(ACCOUNT_ONBOARD, "true");
  };

  useEffectAfterMigration(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    accountOnBoard = localStorage.getItem(ACCOUNT_ONBOARD);

    if (accountOnBoard && isOpen) {
      setIsOpen(false);
    } else if (isUserLoggedIn && !accountOnBoard) {
      localStorage.setItem(ACCOUNT_ONBOARD, "true");
      setIsOpen(true);
    }
  }, [isUserLoggedIn]);

  return (
    <BaseModal title="" isOpen={isOpen} handleClose={handleClose}>
      <div className="flex flex-col gap-4">
        <svg
          width="142"
          height="128"
          viewBox="0 0 142 128"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ margin: "0 auto" }}
        >
          <g clip-path="url(#clip0_13858_11349)">
            <g clip-path="url(#clip1_13858_11349)">
              <g filter="url(#filter0_d_13858_11349)">
                <path
                  d="M58.0005 4.89014L64.7608 18.5485L76.7778 9.17594L76.9425 24.4149L91.836 21.1845L85.3725 34.9858L100.193 38.5373L88.3811 48.1674L100.193 57.7976L85.3725 61.3491L91.836 75.1504L76.9425 71.92L76.7778 87.159L64.7608 77.7864L58.0005 91.4447L51.2401 77.7864L39.2231 87.159L39.0584 71.92L24.1649 75.1504L30.6284 61.3491L15.8082 57.7976L27.6198 48.1674L15.8082 38.5373L30.6284 34.9858L24.1649 21.1845L39.0584 24.4149L39.2231 9.17594L51.2401 18.5485L58.0005 4.89014Z"
                  fill="#57E197"
                />
                <path
                  d="M42.2227 34.6675H74.1112"
                  stroke="#150C09"
                  strokeWidth="6.83326"
                  stroke-linecap="round"
                />
                <path
                  d="M42.2227 48.334H74.1112"
                  stroke="#150C09"
                  strokeWidth="6.83326"
                  stroke-linecap="round"
                />
                <path
                  d="M42.2227 62.0005H67.2779"
                  stroke="#150C09"
                  strokeWidth="6.83326"
                  stroke-linecap="round"
                />
              </g>
            </g>
            <g filter="url(#filter1_d_13858_11349)">
              <path
                d="M70.8861 103.073C69.5661 101.675 67.8032 98.753 64.8768 95.1803C63.2067 93.2232 59.2151 89.5833 57.9266 87.6319C57.0202 86.4579 56.6458 84.9584 56.8942 83.4961C57.2927 80.723 59.6907 78.6785 62.4919 78.7237C64.6767 78.9484 66.7474 79.8098 68.447 81.201C69.6283 82.1173 70.7314 83.1305 71.7446 84.2299C72.4966 85.0047 72.6967 85.3242 73.5447 86.2168C74.3927 87.1094 74.9889 88.0262 74.4743 86.6358C73.979 84.5659 73.137 81.0894 72.1214 78.0107C71.3462 75.6712 71.1841 75.3057 70.5073 73.5496C69.8304 71.7936 69.3916 70.3112 68.6487 68.3074C67.956 66.3351 67.3675 64.3278 66.8854 62.2937C66.1033 59.708 66.2252 56.9331 67.231 54.4259C68.5647 52.9061 70.6804 52.3356 72.5974 52.9789C74.5774 54.1665 76.1389 55.9406 77.0657 58.0552C78.4235 60.6368 79.4284 63.3891 80.0537 66.2382C81.128 70.3699 83.0172 76.3715 83.18 77.6263C83.0309 76.0737 82.4229 72.8289 82.5756 71.332C82.7196 69.7729 83.6618 68.4001 85.0647 67.705C86.2776 67.2016 87.5913 66.9884 88.9011 67.0825C90.2282 67.2296 91.4524 67.8672 92.3336 68.8704C93.5409 71.2251 94.33 73.7716 94.6656 76.3963C94.5566 74.0801 94.732 71.7592 95.1878 69.4856C95.7941 68.4303 96.7497 67.6196 97.8898 67.1934C99.2527 66.8065 100.674 66.67 102.086 66.7904C103.26 67.0615 104.324 67.683 105.137 68.5726C106.239 70.7127 107.003 73.0109 107.4 75.3852C107.457 75.9727 107.537 73.7205 108.319 72.1631C108.662 70.6928 109.763 69.5172 111.208 69.0791C112.653 68.641 114.222 69.0069 115.324 70.0391C116.425 71.0712 116.893 72.6128 116.55 74.0831C116.812 76.8106 116.8 76.6848 116.977 78.5311C117.154 80.3774 117.311 82.014 117.461 83.5666C117.543 86.0368 117.441 88.5098 117.155 90.9647C116.629 93.1629 115.806 95.2792 114.71 97.2555C112.89 99.717 111.452 102.439 110.445 105.33C110.262 106.736 110.256 108.159 110.429 109.567C110.55 110.871 110.844 112.153 111.303 113.379C109.605 113.725 107.875 113.891 106.142 113.875C104.481 113.78 102.152 110.7 101.51 109.746C101.188 109.231 100.603 108.942 99.9987 109C99.3943 109.058 98.8747 109.453 98.6567 110.02C97.8867 111.703 96.1085 114.796 94.6979 115.101C91.9187 115.706 86.0957 115.927 81.5218 116.366C81.5218 116.366 81.8741 112.097 80.0086 110.752C78.1431 109.406 76.2114 107.813 74.7978 106.763L70.8861 103.073Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M70.8861 103.073C69.5661 101.675 67.8032 98.753 64.8768 95.1803C63.2067 93.2232 59.2151 89.5833 57.9266 87.6319C57.0202 86.4579 56.6458 84.9584 56.8942 83.4961C57.2927 80.723 59.6907 78.6785 62.4919 78.7237C64.6767 78.9484 66.7474 79.8098 68.447 81.201C69.6283 82.1173 70.7314 83.1305 71.7446 84.2299C72.4966 85.0047 72.6967 85.3242 73.5447 86.2168C74.3927 87.1094 74.9889 88.0262 74.4743 86.6358C73.979 84.5658 73.137 81.0894 72.1214 78.0107C71.3462 75.6712 71.1841 75.3057 70.5073 73.5496C69.8304 71.7936 69.3916 70.3112 68.6487 68.3074C67.956 66.3351 67.3675 64.3278 66.8854 62.2937C66.1033 59.708 66.2252 56.9331 67.231 54.4259C68.5647 52.9061 70.6804 52.3356 72.5974 52.9789C74.5774 54.1665 76.1389 55.9406 77.0657 58.0552C78.4235 60.6368 79.4284 63.3891 80.0537 66.2382C81.128 70.3699 83.0172 76.3715 83.18 77.6263C83.0309 76.0737 82.4229 72.8289 82.5756 71.332C82.7196 69.7729 83.6618 68.4001 85.0647 67.705C86.2776 67.2016 87.5913 66.9884 88.9011 67.0825C90.2282 67.2296 91.4524 67.8672 92.3336 68.8704C93.5409 71.2251 94.33 73.7716 94.6656 76.3963C94.5566 74.0801 94.732 71.7592 95.1878 69.4856C95.7941 68.4303 96.7497 67.6196 97.8898 67.1934C99.2527 66.8065 100.674 66.67 102.086 66.7904C103.26 67.0615 104.324 67.683 105.137 68.5726C106.239 70.7127 107.003 73.0109 107.4 75.3852C107.457 75.9727 107.537 73.7205 108.319 72.1631C108.662 70.6928 109.763 69.5172 111.208 69.0791C112.653 68.641 114.222 69.0069 115.324 70.0391C116.425 71.0712 116.893 72.6128 116.55 74.0831C116.812 76.8106 116.8 76.6848 116.977 78.5311C117.154 80.3774 117.311 82.014 117.461 83.5666C117.543 86.0368 117.441 88.5098 117.155 90.9647C116.629 93.1629 115.806 95.2792 114.71 97.2555C112.89 99.717 111.452 102.439 110.445 105.33C110.262 106.736 110.256 108.159 110.429 109.567C110.55 110.871 110.844 112.153 111.303 113.379C109.605 113.725 107.875 113.891 106.142 113.875C104.481 113.78 102.152 110.7 101.51 109.746C101.188 109.231 100.603 108.942 99.9987 109C99.3943 109.058 98.8747 109.453 98.6567 110.02C97.8867 111.703 96.1085 114.796 94.6979 115.101C91.9187 115.706 86.0957 115.927 81.5218 116.366C81.5218 116.366 81.8741 112.097 80.0086 110.752C78.1431 109.406 76.2114 107.813 74.7978 106.763L70.8861 103.073Z"
                stroke="black"
                strokeWidth="3.16165"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M106.69 101.947L105.299 87.4629C105.216 86.5959 104.444 85.9607 103.575 86.0442C102.706 86.1277 102.069 86.8982 102.152 87.7652L103.543 102.25C103.626 103.117 104.398 103.752 105.267 103.668C106.137 103.585 106.774 102.814 106.69 101.947Z"
                fill="black"
              />
              <path
                d="M98.3821 102.741L96.9065 88.2568C96.8185 87.3924 96.043 86.7633 95.1744 86.8517C94.3058 86.9402 93.6731 87.7127 93.7611 88.5771L95.2367 103.061C95.3248 103.925 96.1003 104.555 96.9689 104.466C97.8374 104.378 98.4702 103.605 98.3821 102.741Z"
                fill="black"
              />
              <path
                d="M85.3691 89.397L86.8417 103.851C86.9307 104.724 87.7069 105.359 88.5754 105.271C89.444 105.182 90.076 104.403 89.9871 103.53L88.5144 89.0763C88.4255 88.2036 87.6493 87.5679 86.7807 87.6564C85.9122 87.745 85.2801 88.5242 85.3691 89.397Z"
                fill="black"
              />
            </g>
          </g>
          <defs>
            <filter
              id="filter0_d_13858_11349"
              x="6.16748"
              y="0.334473"
              width="103.666"
              height="103.666"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_13858_11349"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_13858_11349"
                result="shape"
              />
            </filter>
            <filter
              id="filter1_d_13858_11349"
              x="51.8659"
              y="51.1372"
              width="70.5759"
              height="74.3975"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4.21554" />
              <feGaussianBlur stdDeviation="1.68622" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_13858_11349"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_13858_11349"
                result="shape"
              />
            </filter>
            <clipPath id="clip0_13858_11349">
              <rect
                width="141"
                height="128"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
            <clipPath id="clip1_13858_11349">
              <rect
                width="95.6656"
                height="95.6656"
                fill="white"
                transform="translate(10.1675 0.334473)"
              />
            </clipPath>
          </defs>
        </svg>
        <h3 className="text-[#150C09] text-center font-nunito text-[24px] font-extrabold leading-normal">
          Your Mathler stats are now saved across devices
        </h3>
        <div className="text-[#150C09] font-nunito text-[18px] leading-normal flex flex-col gap-4">
          <p>
            We transferred your total games played and best win streak into your
            new{" "}
            <a
              className="font-bold underline"
              href={`https://play.hey.gg/mathler/dashboard?return_to=${encodeURIComponent(window.location.href)}`}
            >
              stats dashboard
            </a>
            .
          </p>
          <p>
            There, you can view streaks, leaderboards, profile settings, and
            even dark mode preferences.
          </p>
          <p>
            Oh, and don’t forget to share your stats in our new{" "}
            <a
              className="font-bold underline"
              href="https://discord.com/channels/974103380127526942/1097907040929726515"
            >
              game community
            </a>
            !
          </p>
        </div>
        <button
          type="button"
          className="rounded-md border-2 border-[#150C09] bg-[#5EC26A] w-full h-[50px] mx-auto text-[#071E12] text-center text-sm font-extrabold shadow-custom-small-black mt-4
  hover:shadow-[5px_5px_0px_#150c09] hover:-translate-x-1 hover:-translate-y-1 active:translate-x-1 active:translate-y-1 active:shadow-none"
          onClick={() => {
            window.location.href =
              "https://play.hey.gg/dashboard/mathler?return_to=" +
              encodeURIComponent(window.location.href);
          }}
        >
          VIEW YOUR STATS DASHBOARD
        </button>
      </div>
    </BaseModal>
  );
}
